import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-modal-renovar-sessao',
    standalone: false,
    templateUrl: './modal-renovar-sessao.component.html',
    styleUrls: ['./modal-renovar-sessao.component.css']
})
export class ModalRenovarSessaoComponent implements OnInit, OnDestroy {
    visible = false;
    segundosRestantes = 0;
    progressValue = 100;
    private intervalId?: number;
    private tempoInicial = 0;
    private resolvePromise?: (value: boolean) => void;

    constructor(private toastr: ToastrService) { }

    ngOnInit() { }

    ngOnDestroy() {
        this.pararContador();
    }

    mostrar(segundos: number) {
        return new Promise((resolve) => {
            this.resolvePromise = resolve;
            this.segundosRestantes = segundos;
            this.tempoInicial = segundos;
            this.visible = true;
            this.progressValue = 100;
            this.iniciarContador();
        });
    }

    private iniciarContador() {
        this.pararContador();
        this.intervalId = window.setInterval(() => {
            this.segundosRestantes--;
            this.progressValue = (this.segundosRestantes / this.tempoInicial) * 100;

            if (this.segundosRestantes <= 0) {
                this.sair();
            }
        }, 1000);
    }

    private pararContador() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }

    async renovarSessao() {
        this.pararContador();
        this.visible = false;
        if (this.resolvePromise) {
            this.resolvePromise(true);
        }
    }

    sair() {
        this.pararContador();
        this.visible = false;
        this.toastr.warning('Sua sessão expirou. Por favor, faça login novamente.');
        setTimeout(() => {            
            if (this.resolvePromise) {
                this.resolvePromise(false);
            }
        }, 3000);
    }
}